export enum enumEntrySummaryRoutingTitle {
  ES_LIST,
  ES,
  ES_NEW,
  BL_NEW,
  BL,
  INVOICE_NEW,
  INVOICE,
  LINE_ITEM_NEW,
  LINE_ITEM,
  INVOICES,
  CUSTOM_BROKER,
}

export const entrySummaryRoutingTitleKeyMap: Map<enumEntrySummaryRoutingTitle, string> = new Map<enumEntrySummaryRoutingTitle, string>([
  [enumEntrySummaryRoutingTitle.ES_LIST, 'LABELS.ENTRY_SUMMARY'],
  [enumEntrySummaryRoutingTitle.ES_NEW, 'LABELS.NEW_ES'],
  [enumEntrySummaryRoutingTitle.ES, 'DASHBOARD_TITLE.ENTRY_SUMMARY_REF'],
  [enumEntrySummaryRoutingTitle.BL_NEW, 'DASHBOARD_TITLE.NEW_BILL_OF_LADING'],
  [enumEntrySummaryRoutingTitle.BL, 'DASHBOARD_TITLE.BILL_OF_LADING'],
  [enumEntrySummaryRoutingTitle.INVOICE_NEW, 'DOCUMENT_TYPE.FREIGHT_USER_INVOICE'],
  [enumEntrySummaryRoutingTitle.INVOICE, 'DASHBOARD_TITLE.INVOICE'],
  [enumEntrySummaryRoutingTitle.LINE_ITEM_NEW, 'DASHBOARD_TITLE.NEW_LINE_ITEM'],
  [enumEntrySummaryRoutingTitle.LINE_ITEM, 'DASHBOARD_TITLE.LINE_ITEM'],
  [enumEntrySummaryRoutingTitle.INVOICES, 'DASHBOARD_TITLE.INVOICES'],
  [enumEntrySummaryRoutingTitle.CUSTOM_BROKER, 'DASHBOARD_TITLE.CUSTOM_BROKER'],
]);
